$(document).ready(function() {
  $('.sticky-wrap-myaccount-menu').stickyBox({
      spaceTop: document.querySelector('.header').offsetHeight,
      stopper: '.shopify-section-group-footer-group'
  });
  jQuery(document).on('change', '.mobile-side-nav select', function() {
      window.location = $(this).find(':selected').attr('data-url');
  })
  jQuery('.mobile-side-nav select').select2({
      minimumResultsForSearch: -1
  });
});


if (window.location.pathname.includes("/account/addresses") && getQueryParam('address_id')) {
  var edit_address_id = getQueryParam('address_id');
  var edit_address_selector = `#btn-edit-${edit_address_id}`;
  if (document.querySelector(edit_address_selector)) {
      setTimeout(function() {
          console.log(document.querySelector(edit_address_selector))
          document.querySelector(edit_address_selector).click();
          document.querySelector('body').style.visibility = 'visible';
      }, 1000);
  } else {
      document.querySelector('body').style.visibility = 'visible';

  }
} else {
  document.querySelector('body').style.visibility = 'visible';

}


if (!window.location.pathname.includes('account/addresses')) {
  if (getQueryParam('page')) {
      document.querySelector('#section-order-list').style.display = 'block';
      // document.querySelector('.woocommerce-MyAccount-navigation-link--orders').classList.add('is-active');
  } else {
      // document.querySelector('#section-account').style.display = 'block';
      document.querySelector('#section-myaccount-form').style.display = 'block';
      if(document.querySelector('.woocommerce-MyAccount-navigation-link--account')){
        document.querySelector('.woocommerce-MyAccount-navigation-link--account').classList.add('is-active');
      }
    
  }
  jQuery(document).on('click', '.order-detail-opener', function(event) {
      event.preventDefault();
      jQuery(this).closest('.account-detail-block').toggleClass('order_detail_active');
      jQuery(this).closest('.single-order-details').find('.details-wrap').slideToggle();
  });
}

// Cutomer feedback form
// document.getElementById("customer-feedback-form").addEventListener("submit", function (e) {
//   e.preventDefault();

//   const form = e.target;
//   const formData = new FormData(form);
//   const file = formData.get("picture_1");

//   const data = {
//     order_id: formData.get("order_id"),
//     item_id: formData.get("item_id"),
//     item_sku: formData.get("item_sku"),
//     item_name: formData.get("item_name"),
//     customer_name: formData.get("customer_name"),
//     customer_email: formData.get("customer_email"),
//     customer_phone: formData.get("customer_phone"),
//     problem_type: formData.get("problem_type"),
//     message: formData.get("message"),
//     file_base64: null // default
//   };

//   // If file exists, read and encode as base64
//   if (file && file.name) {
//     const reader = new FileReader();
//     reader.onload = function () {
//       data.file_base64 = reader.result;
//       sendDataToAPI(data); // send once base64 is ready
//     };
//     reader.readAsDataURL(file); // triggers reader.onload
//   } else {
//     sendDataToAPI(data); // send without file
//   }
// });

// function sendDataToAPI(data) {
//   fetch("https://erborian-comax.matat.io/api/add-customer-feedback", {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json"
//     },
//     body: JSON.stringify(data)
//   })
//     .then(response => {
//       if (!response.ok) {
//         throw new Error("Server responded with status: " + response.status);
//       }
//       return response.json();
//     })
//     .then(responseData => {
//       console.log("Success:", responseData);
//       document.querySelector(".dispute-modal-wrapper")?.classList.add("form_successfully");
//     })
//     .catch(error => {
//       console.error("Error:", error);
//     });
// }

document.querySelectorAll(".customer-feedback-form").forEach(function (form) {
  form.addEventListener("submit", function (e) {
    e.preventDefault();

    const fileInput = form.querySelector('input[type="file"]');
    const file = fileInput.files[0];
    const formData = new FormData(form);

    const disputeWrapper = form.closest(".dispute-modal-wrapper");

    if (file) {
      const reader = new FileReader();
      reader.onload = function () {
        const base64File = reader.result.split(',')[1];
        formData.delete("picture_1");
        formData.append("picture_1_base64", base64File);
        formData.append("file_name", file.name);
        formData.append("file_type", file.type);

        sendFeedback(formData, disputeWrapper);
      };
      reader.readAsDataURL(file);
    } else {
      sendFeedback(formData, disputeWrapper);
    }

    function sendFeedback(data, wrapper) {
      fetch("https://erborian-comax.matat.io/api/add-customer-feedback", {
        method: "POST",
        body: data
      })
        .then(response => response.json())
        .then(responseData => {
          // console.log("Success:", responseData);

          // Add class to dispute-modal-wrapper
          if (wrapper) {
            wrapper.classList.add("form_successfully");
          }
        })
        .catch(error => {
          console.error("Error:", error);
          alert("Failed to submit feedback.");
        });
    }
  });
});
document.querySelectorAll(".dispute-finish-button").forEach(function (btn) {
  btn.addEventListener("click", function () {
    const modal = btn.closest(".dispute-modal");
    if (modal && modal.classList.contains("active")) {
      modal.classList.remove("active");
    }
  });
});


// Order page popup js
document.querySelectorAll('.view_order').forEach(button => {
  button.addEventListener('click', function () {
    const orderId = this.getAttribute('data-id');
    if (!orderId) return;
    document.querySelectorAll('.view_order_model').forEach(modal => {
      modal.classList.remove('active');
    });
    const targetModal = document.querySelector(`.view_order_model[data-id="${orderId}"]`);
    if (targetModal) {
      targetModal.classList.add('active');
    }
  });
});
document.querySelectorAll('.button_close').forEach(closeBtn => {
  closeBtn.addEventListener('click', function () {
    this.closest('.view_order_model').classList.remove('active');
  });
});
document.querySelectorAll('.view_order_model').forEach(modal => {
  modal.addEventListener('click', function (e) {
    if (e.target === this) {
      this.classList.remove('active');
    }
  });
});

// Product report popup js
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.product-report').forEach(function (reportButton) {
    reportButton.addEventListener('click', function () {
      const orderId = this.getAttribute('data-id');
      const matchingModal = document.querySelector(`#disputeModal[data-id="${orderId}"]`);
      if (matchingModal) {
        matchingModal.classList.add('active');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#disputeModal .button_close')) {
      const modal = e.target.closest('#disputeModal');
      if (modal) modal.classList.remove('active');
    }

    if (e.target.id === 'disputeModal' && e.target.classList.contains('dispute-modal')) {
      e.target.classList.remove('active');
    }
  });
});

// Reoreder js
this.reorder = new function () {
  var self = this;
  this.pushQueue = function (i, data, el) {
    if (data[i].check_inventory) {
      data[i].quantity = Math.min(parseInt(data[i].inventory), parseInt(data[i].quantity));
    }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        quantity: data[i].quantity,
        id: data[i].id
      })
    }).finally(() => {
      if (i >= data.length - 1) {
        // Send the fetch request
            const config = fetchConfig('javascript');
            const response = fetch(`${routes.cart_add_url}`, config)
            .then(response => {
                return response.json();
            }).then((data) => {
                fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
                .then((response) => response.json())
                .then((response) => {
                    let responseFormated = {
                        sections: response
                    }
                    let cart_drawer = document.querySelector('cart-drawer');
                    cart_drawer.renderContents(responseFormated)
                    el.classList.remove('loading');
                })
                if(document.querySelector("cart-drawer").classList.contains("is-empty")){
                    document.querySelector("cart-drawer").classList.remove("is-empty");
                }
            })
            .catch((error) => {
                console.error('Error:', error);
            });
      } else {
        self.pushQueue(i + 1, data, el);
      }
    });
  };

  this.listen = function (event) {
    var el = event.currentTarget;
    var ids = el.getAttribute('data-variant-ids').split(',');
    var quantities = el.getAttribute('data-variant-quantities').split(',');
    var inventories = el.getAttribute('data-variant-inventories').split(',');
    var inventory_policies = el.getAttribute('data-variant-inventory-policies').split(',');
    var inventory_trackers = el.getAttribute('data-variant-inventory-trackers').split(',');
    if (ids[ids.length - 1] === '') {
      ids.pop();
      quantities.pop();
      inventories.pop();
      inventory_policies.pop();
      inventory_trackers.pop();
    }
    var data = [];
    for (var i = 0; i < ids.length; i++) {
      data.push({
        id: ids[i],
        quantity: quantities[i],
        inventory: inventories[i],
        check_inventory: (inventory_policies[i] === "deny" && inventory_trackers[i] !== "")
      });
    }
    el.classList.add('loading');
    self.pushQueue(0, data, el);
  };

  this.init = function () {
    var buttons = document.querySelectorAll('.reorder-btn');
    buttons.forEach(function (btn) {
      btn.addEventListener('click', self.listen);
    });
  };
};

document.addEventListener('DOMContentLoaded', function () {
  reorder.init();
});